import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { logger } from '../../../common/utils/logger';

import type { ConversationStarter } from './conversation-starters';

export const onConvoStarterClick = (props: {
	starter: ConversationStarter;
	analyticsAttributes: any;
	starterIndex: number;
}): AnalyticsEventPayload => {
	const { starter: starterText, isSummarize, isShowMore, isShowLess } = props.starter;
	try {
		return {
			action: 'clicked',
			actionSubject: 'aiConvoStarter',
			eventType: 'ui',
			attributes: {
				...props.analyticsAttributes,
				starterIndex: props.starterIndex,
				isSummarize,
				isShowMore,
				isShowLess,
			},
			nonPrivacySafeAttributes: {
				starter: starterText,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onConversationStarterClick' });
		return {};
	}
};

export const onConvoStartersShown = (props: {
	starters: string[];
	analyticsAttributes: any;
}): AnalyticsEventPayload => {
	try {
		return {
			action: 'shown',
			actionSubject: 'aiConvoStarters',
			eventType: 'track',
			attributes: {
				...props.analyticsAttributes,
				startersCount: props.starters.length,
			},
			nonPrivacySafeAttributes: {
				starters: props.starters,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onConvoStarterShown' });
		return {};
	}
};

export const onConvoStartersFailed = (props: {
	analyticsAttributes: any;
	error: string;
}): AnalyticsEventPayload => {
	try {
		return {
			action: 'failed',
			actionSubject: 'aiConvoStarters',
			eventType: 'track',
			attributes: {
				...props.analyticsAttributes,
				error: props.error,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onConvoStartersFailed' });
		return {};
	}
};
